(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sidenavbaritem", [], factory);
	else if(typeof exports === 'object')
		exports["sidenavbaritem"] = factory();
	else
		root["sidenavbaritem"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 